import Main from "./components/main/main";

function App() {
	return (
		<div className="App">
			<Main />
		</div>
	);
}

export default App;
